import { useEffect, useRef } from 'react';
import { io, type Socket } from 'socket.io-client';
import { authUtils } from '@shared/utils/axios-instance';
import {
  CLIENT_ORDER_CHAT_EVENTS,
  CLIENT_ORDER_CHAT_WS_NAMESPACE,
  CLIENT_ORDER_CHAT_WS_PATH,
  type ClientOrderChatMessageEvent,
} from '../types';

type Handlers = {
  onMessage?: (payload: ClientOrderChatMessageEvent) => void;
  onUnread?: (payload: {
    scope: 'client' | 'admin' | 'seller';
    count: number;
  }) => void;
};

export function useClientOrderChatSocket(handlers: Handlers, enabled = true) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!enabled) return undefined;

    const token = authUtils.getAccessToken();
    if (!token) return undefined;

    const socket: Socket = io(CLIENT_ORDER_CHAT_WS_NAMESPACE, {
      path: CLIENT_ORDER_CHAT_WS_PATH,
      transports: ['websocket', 'polling'],
      auth: {
        token,
        client: 'seller-admin',
      },
    });

    socket.on(CLIENT_ORDER_CHAT_EVENTS.messageNew, (payload) => {
      handlersRef.current.onMessage?.(payload);
    });
    socket.on(CLIENT_ORDER_CHAT_EVENTS.unread, (payload) => {
      handlersRef.current.onUnread?.(payload);
    });

    return () => {
      socket.disconnect();
    };
  }, [enabled]);
}
